import CheckWebpFeature from "./src/components/common/ggfx-client/module/webp-checker";
CheckWebpFeature();
// export const onInitialClientRender = () => {
//   if (!location.hostname.includes("netlify.app")) {
//     (function (w, d, s, l, i) {
//       w[l] = w[l] || [];
//       w[l].push({
//         'gtm.start': new Date().getTime(),
//         event: 'gtm.js'
//       });
//       var f = d.getElementsByTagName(s)[0],
//           j = d.createElement(s),
//           dl = l != 'dataLayer' ? '&l=' + l : '';
//       j.async = true;
//       j.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-56QX4K5' + dl;
//       f.parentNode.insertBefore(j, f);
//     })(window, document, 'script', 'dataLayer', 'GTM-56QX4K5');
//   }
// };

export { wrapRootElement } from "./src/apollo/wrap-root-element";

export const disableCorePrefetching = () => true

export const onRouteUpdate = ({ location, prevLocation }) => {
  // console.log('new pathname', location.pathname)
  // console.log('old pathname', prevLocation ? prevLocation.pathname : null)
  if (prevLocation && (prevLocation.pathname == '/' || prevLocation.pathname == '/buy-property/' || prevLocation.pathname == '/rent/' || prevLocation.pathname.indexOf("property-for-sale") >= 0 || prevLocation.pathname.indexOf("property-to-rent") >= 0)) {
    if (window)
      window.scroll({
        top: -100,
        behavior: 'smooth'
      });
  }
}

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition
}) => {

  // Avoid to scroll to top when next page trigger click
  // But this feature should condiser with details page back scroll too

  if (location.pathname.match(/property\/for-sale/)) {
    return false;
  }
  // if (location.pathname.match(/property-for-sale/)) {
  //   return false;
  // }
  // if (location.pathname.match(/property-to-rent/)) {
  //   return false;
  // }
  // if (location.pathname.match(/new-home-for-sale/)) {
  //   return false;
  // }
  if (location.pathname.match(/property\/to-rent/)) {
    return false;
  }
  if (location.pathname.match(/property\/new-homes\/for-sale/)) {
    return false;
  }


  return true;
};
